import { useCallback, useState } from "react";

export function useToggle(
  initialState: boolean,
): [boolean, (value?: boolean) => () => void] {
  const [state, setState] = useState(initialState);

  const toggle = useCallback(
    (value?: boolean) => () => {
      if (typeof value === "boolean") {
        setState(value);
        return;
      }

      setState((currentState) => !currentState);
    },
    [],
  );

  return [state, toggle];
}
